export class DteRecibidoFilter {
	nombreProveedor: string = "";
	rutProveedor: string = "";
	emisorId: string;
	tipoDteId: string;
	fechaDesde: Date;
	fechaHasta: Date;
	fechaVencimientoDesde: Date;
	fechaVencimientoHasta: Date;
	fechaRecepcionDesde: Date;
	fechaRecepcionHasta: Date;
	estadoSii: number;
	rutEmisor: string;
	estado: number;
	folio: string = "";
	respuestaEstadoDte: string = "";
	montoTotal: number;
	nulos: boolean;
	tieneNC: boolean;
	cedida: boolean;
}
